import React from 'react';
import { getConfig } from '@alfa-bank/newclick-core/utils';
import cn from 'classnames';

import { Text, TitleDesktop } from '@alfalab/core-components/typography';

import { ALT_DOMAIN } from '../../../shared/constants/urls';
import { QrCode } from '../qr-code';

import styles from './index.module.css';

type Props = {
    className?: string;
};

export const Hero = ({ className }: Props) => {
    const { altDomain } = getConfig();

    return (
        <section
            className={cn(className, styles.container, { [styles.altDomain]: altDomain })}
            aria-labelledby='hero-heading'
            data-test-id='hero'
        >
            <div className={styles.description}>
                <TitleDesktop
                    className={styles.title}
                    id='hero-heading'
                    tag='h1'
                    view='xlarge'
                    font='system'
                    weight='bold'
                >
                    {altDomain ? (
                        <React.Fragment>
                            Новый адрес
                            <br />
                            веб-приложения&nbsp;&mdash; {ALT_DOMAIN}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            Веб-приложение
                            <br />
                            для айфона
                        </React.Fragment>
                    )}
                </TitleDesktop>
                <Text>
                    Обновляется автоматически и&nbsp;не&nbsp;занимает места.
                    <br />
                    Чтобы установить, наведите камеру на&nbsp;QR-код и&nbsp;перейдите по&nbsp;ссылке
                </Text>
            </div>

            <QrCode className={styles.qrCode} />
        </section>
    );
};
